module.exports = __webpack_public_path__ + "static/media/uk_map.60002546.svg";